import React from 'react';

const StatCard = ({ icon: Icon, label, value, color = 'primary', trend = null }) => {
  const colorClass = {
    primary: 'primary',
    success: 'success',
    warning: 'warning',
    error: 'error',
  }[color] || 'primary';

  return (
    <div className={`stat-card ${colorClass}`}>
      <div className="stat-icon" style={{ color: `var(--${colorClass === 'primary' ? 'primary' : colorClass}-color)` }}>
        <Icon />
      </div>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {trend && (
        <div style={{ fontSize: '0.875rem', marginTop: '0.5rem', color: trend.positive ? 'var(--success-color)' : 'var(--error-color)' }}>
          {trend.positive ? '↑' : '↓'} {trend.percentage}% depuis le mois dernier
        </div>
      )}
    </div>
  );
};

export default StatCard;
